import { defineComponent as _, useAttrs as x, ref as r, watchEffect as $, computed as u, createElementBlock as l, openBlock as a, mergeProps as f, createElementVNode as o, createVNode as p, unref as m, createCommentVNode as c, renderSlot as s, normalizeClass as B, normalizeStyle as E, withCtx as V } from "vue";
import { useResizeObserver as z } from "@vueuse/core";
import N from "../../icons/generated/IconChevronDown.vue2.js";
import { tw as h } from "../../utils/tailwind.js";
import R from "./components/TransitionContent.vue2.js";
const S = {
  key: 0,
  class: "mr-8 block size-24"
}, I = { class: "flex grow flex-col" }, T = { class: "flex grow flex-row items-start" }, F = { class: "text-action-default-hi body-1 w-full max-w-full" }, H = { class: "ml-auto block" }, L = {
  key: 0,
  class: "body-2 w-full max-w-full"
}, J = /* @__PURE__ */ _({
  name: "RevAccordionItem",
  inheritAttrs: !1,
  __name: "AccordionItem",
  props: {
    collapsed: { default: "auto" },
    wrapperAttrs: { default: () => ({}) },
    keepContentAlive: { type: Boolean, default: !1 },
    renderBody: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(v, { emit: g }) {
    const d = v, y = g, b = x(), t = r(!1);
    $(() => {
      const e = {
        auto: !1,
        expanded: !0,
        collapsed: !1
      };
      t.value = e[d.collapsed];
    });
    const w = u(() => d.collapsed === "auto");
    function C(e) {
      y("click", e), w.value && (t.value = !t.value);
    }
    const k = u(() => [
      h`transition-transform duration-200 ease-in`,
      t.value && h`rotate-180`
    ]), n = r(), i = r(t.value ? "auto" : "0px");
    function A(e) {
      t.value || (e.setAttribute("style", "height: 0px"), i.value = "0px");
    }
    return z(n, () => {
      t.value && (i.value = `${n.value.getBoundingClientRect().height}px`);
    }), (e, O) => (a(), l("li", f(e.wrapperAttrs, { class: "relative list-none tap-highlight-transparent" }), [
      o("button", f(m(b), {
        class: "bg-static-default-min text-static-default-low focus-visible-outline-default-hi flex w-full cursor-pointer items-start overflow-hidden rounded-none border-0 px-24 py-20 text-left no-underline hover:bg-static-default-min-hover motion-safe:transition motion-safe:duration-200",
        onClick: C
      }), [
        e.$slots.prefix ? (a(), l("span", S, [
          s(e.$slots, "prefix")
        ])) : c("", !0),
        o("span", I, [
          o("span", T, [
            o("span", F, [
              s(e.$slots, "title")
            ]),
            o("span", H, [
              e.$slots.image ? c("", !0) : (a(), l("span", {
                key: 0,
                class: B(["block h-24", k.value])
              }, [
                p(m(N))
              ], 2)),
              s(e.$slots, "image")
            ])
          ]),
          e.$slots.description ? (a(), l("span", L, [
            s(e.$slots, "description")
          ])) : c("", !0)
        ])
      ], 16),
      p(R, {
        class: "text-static-default-mid body-2",
        condition: t.value,
        "keep-alive": e.keepContentAlive,
        "render-body": e.renderBody,
        style: E({ height: i.value }),
        "transition-props": {
          enterActiveClass: "overflow-y-hidden transition-height duration-300 ease-in will-change-[height]",
          enterFromClass: "h-0",
          leaveActiveClass: "overflow-y-hidden transition-height duration-300 ease-in will-change-[height]",
          leaveToClass: "h-0"
        },
        onLeave: A
      }, {
        default: V(() => [
          o("div", {
            ref_key: "accordionContentEl",
            ref: n,
            class: "px-24 pb-20 pt-8"
          }, [
            s(e.$slots, "body")
          ], 512)
        ]),
        _: 3
      }, 8, ["condition", "keep-alive", "render-body", "style"])
    ], 16));
  }
});
export {
  J as default
};
